/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$.date = function(dateObject) {
    var d = new Date(dateObject);
    var day = d.getDate();
    var month = d.getMonth() + 1;
    var year = d.getFullYear();
    if (day < 10) {
        day = "0" + day;
    }
    if (month < 10) {
        month = "0" + month;
    }
    var date = day + "/" + month + "/" + year;

    return date;
};

$(document).ready(function() {
    $('.ProductMeta__Description, .SectionHeader__Accordion').find('h5').each(function(e){
      $(this).nextUntil('h5').wrapAll("<div class='toggle-group'></div>");
    });
  	$('.ProductMeta__Description h5, .ProductMeta__Description .toggle-group').wrapAll('<div class="toggle-block" />');
  
    $('.SectionHeader__Accordion').each(function() {
      $('h5, .toggle-group',this).add($(this).next().not('.SectionHeader__Description')).wrapAll('<div class="toggle-block" />');
    });
    $('.ProductMeta__Description, .SectionHeader__Accordion').find('h5').click(function(e){
      e.preventDefault();
      $(this).next().slideToggle();
      if($(this).hasClass('active')) {
        $('h5').removeClass('active');
      } else {
        $('h5').removeClass('active');
        $(this).addClass('active');
      }    
	});
    $('[aria-controls="modal-form"]').click(function() {
      $('.shopify-section--header, .ProductRecommendations').css('visibility','hidden');
    });
    $('.close-form').click(function() {
      $('.shopify-section--header, .ProductRecommendations').css('visibility','visible');
    });
    if ($('#modal-form .Alert--success').length) {
      $('[aria-controls="modal-form"]').trigger('click');
    }
    function getUrlVars()
    {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }
	var thedate = getUrlVars()["select"];
    if (thedate) {
      $('.blueish').text($.date(thedate));
      $('#courseDate').val($.date(thedate));
      $('#appDate').val($.date(thedate));
    }
});